import { isValid } from 'date-fns';
import { Plugin } from 'shared/domains/pleditor@next';
export class VersionDiagnostics extends Plugin {
    static get pluginName() {
        return 'VersionDiagnostics';
    }
    constructor(editor) {
        super(editor);
        this.set('updatedAt', new Date(1970).toISOString());
    }
    init() {
        // This runs when the model is applying all created operations
        // We want to filter out operations that do not alter the documents content
        // https://ckeditor.com/docs/ckeditor5/latest/features/collaboration/users.html#operation-authors
        this.editor.model.on('applyOperation', (evt, [operation]) => {
            if (operation.isDocumentOperation && this.affectsData(operation) && isValid(new Date(operation.createdAt))) {
                this.updatedAt = new Date(operation.createdAt).toISOString();
            }
        });
        // This makes sure that we first make sure the editor is ready and then we start to listen to changes to the data after that
        this.editor.on('ready', () => {
            this.editor.model.document.on('change:data', () => {
                this.updatedAt = new Date().toISOString();
            });
        });
    }
    // eslint-disable-next-line class-methods-use-this
    affectsData(operation) {
        return operation.type !== 'noop' && (operation.type !== 'marker' || operation.affectsData);
    }
}
